import { BydCleanInstance, BYD_CLEAN_INSTANCE_KEY } from '@sixense/byd-clean-instance';
import { DsFormInstanceSchemaFieldInterface } from '../interfaces/form-instance/ds-form-instance-schema-field.interface';
import { DsFormInstanceFieldValueType } from '../types/ds-form-instance-field-value.type';
import { DsFormInstanceTableColumn } from './ds-form-instance-table-column';
import { DsFormInstanceTableRow } from './ds-form-instance-table-row';
import { DsFormInstanceTableValue } from './ds-form-instance-table-value';
import { DsFormInstanceTableValueFront } from './ds-form-instance-table-value-front';

@BydCleanInstance
@Reflect.metadata(BYD_CLEAN_INSTANCE_KEY, [null, undefined, []])
export class DsFormInstanceSchemaField {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public value: DsFormInstanceFieldValueType;

  /**
   *
   */
  public option?: string[];

  /**
   *
   */
  public comment?: string;

  /**
   *
   */
  public photos?: string[];

  /**
   *
   */
  public isFixed?: boolean;

  /**
   *
   */
  public isLocked?: boolean;

  /**
   *
   */
  public isSigned?: boolean;

  /**
   *
   */
  public rowCount?: number;

  /**
   *
   */
  public cellPhotos?: string[];

  /**
   * Creates an instance of DsFormInstanceSchemafield.
   *
   * @param json the json data
   * @param template instance template
   */
  constructor(json: DsFormInstanceSchemaFieldInterface) {
    this.id = json?.id;
    this.option = json?.option;
    this.isFixed = json?.isFixed;
    this.isLocked = json?.isLocked;
    this.isSigned = json?.isSigned;
    this.comment = json?.comment;
    this.value = json?.value;
    this.photos = json?.photos;
    this.cellPhotos = json?.cellPhotos;
    this.rowCount = json?.rowCount;
    if (json?.rowCount !== null && json?.rowCount !== undefined && json?.value) {
      const cells = [];
      (<DsFormInstanceTableValueFront>json.value)?.rows.forEach((row: DsFormInstanceTableRow, index: number) => {
        row.columns.forEach((column: DsFormInstanceTableColumn) => {
          const ref = {
            rowIndex: index,
            columnIndex: column.index,
          };
          const cell = new DsFormInstanceTableValue(ref, column.value);
          if (cell?.value !== null && cell?.value !== undefined) cells.push(cell);
        });
      });

      this.value = cells;
    }
  }
}
